module.exports = __webpack_public_path__ + "img/ea_bg1.74251c75.jpg";